module.exports = __webpack_public_path__ + "img/qrcode_sydyr.5accccf6.png";